import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { ScheduleOptionPreview } from "../poll-preview.type";
import { isToday } from 'date-fns'
import { MatTooltipModule } from "@angular/material/tooltip";
import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: 'schedule-preview',
    templateUrl: 'schedule-preview.component.html',
    styleUrls: ['./schedule-preview.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        TranslateModule,
        MatTooltipModule
    ]
})
export class SchedulePreviewComponent {

    @Input() options: ScheduleOptionPreview; 
  
    constructor() {}

    protected isToday(date: Date){
        return isToday(date);
    }
}

